<template>
  <zm-breadcrumb class="app-breadcrumb" separator-class="zm-icon-right">
    <transition-group name="breadcrumb">
      <zm-breadcrumb-item
        v-for="(item, index) in levelList"
        :key="item.name + '_' + item.path"
      >
        <span
          v-if="item.redirect === 'noredirect' || index == levelList.length"
          class="no-redirect"
          >{{ item.name }}</span
        >
        <router-link
          v-else-if="item.name !== 'TaskDetail'"
          :to="item.redirect || item.path"
          >{{ item.name }}</router-link
        >
        <div v-else>{{ item.name }}</div>
      </zm-breadcrumb-item>
      <zm-breadcrumb-item
        key="triggerId"
        v-if="levelList.length && levelList[1].name === 'Triggers'"
      >
        <span>{{ triggerId }}</span>
      </zm-breadcrumb-item>
      <zm-breadcrumb-item key="kafkaManage" v-if="isKafkaManage">
        <zm-dropdown trigger="click" @command="handleCommand">
          <span class="zm-dropdown-link">
            {{ kafkaPath.name }}<i class="zm-icon-down zm-icon--right"></i>
          </span>
          <zm-dropdown-menu slot="dropdown">
            <zm-dropdown-item
              v-if="kafkaPath.name !== 'Dashboard'"
              command="dashboard"
              >Dashboard
            </zm-dropdown-item>
            <zm-dropdown-item
              v-if="kafkaPath.name !== 'Cluster'"
              command="cluster"
              >Cluster
            </zm-dropdown-item>
            <zm-dropdown-item v-if="kafkaPath.name !== 'Alert'" command="alert"
              >Alert
            </zm-dropdown-item>
            <zm-dropdown-item
              v-if="kafkaPath.name !== 'Reassign'"
              command="reassign"
              >Reassign
            </zm-dropdown-item>
            <zm-dropdown-item
              v-if="kafkaPath.name !== 'Webhook'"
              command="webhook"
              >Webhook
            </zm-dropdown-item>
            <zm-dropdown-item v-if="kafkaPath.name !== 'ACL'" command="acl"
              >ACL
            </zm-dropdown-item>
            <zm-dropdown-item v-if="kafkaPath.name !== 'Token'" command="token"
              >Token
            </zm-dropdown-item>
            <zm-dropdown-item v-if="kafkaPath.name !== 'Scram'" command="scram"
              >Scram
            </zm-dropdown-item>
          </zm-dropdown-menu>
        </zm-dropdown>
      </zm-breadcrumb-item>
      <zm-breadcrumb-item
        key="triggerId"
        v-if="modernRoutes.includes(currentRoute) && isRequestModernClassicMode"
      >
        <router-link
          :to="`/dashboard/${toggleRoute}`"
          :id="`classic${currentRoute}`"
          >Classic</router-link
        >
      </zm-breadcrumb-item>
      <zm-breadcrumb-item
        key="triggerId"
        v-if="
          classicRoutes.includes(currentRoute) && isRequestModernClassicMode
        "
      >
        <router-link :to="`/dashboard/${toggleRoute}`">Morden</router-link>
      </zm-breadcrumb-item>
    </transition-group>
  </zm-breadcrumb>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  created() {
    this.getBreadcrumb()
    this.upadteConfig()
  },
  data() {
    return {
      levelList: null,
      isKafkaManage: false,
      kafkaPath: {},
      triggerId: '',
      classicRoutes: Object.freeze(['ClassicTask', 'ClassicRequest']),
      modernRoutes: Object.freeze(['Task', 'Request'])
    }
  },
  watch: {
    $route() {
      this.isKafkaManage = false
      this.getBreadcrumb()
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name
    },
    currentRouteFormatted() {
      return this.$route.name.startsWith('Classic') ? this.$route.name.slice(7) : this.$route.name
    },
    toggleRoute() {
      return this.$route.meta.toggle
    },
    ...mapState('globalconfig', ['configList']),
    isRequestModernClassicMode() {
      // if pagemode hasn't set, default is 0
      if (!this.configList.length || !this.configList.find(x => x.configName === `${this.currentRouteFormatted}PageMode`)) return true
      return this.configList.findIndex(i => `${this.currentRouteFormatted}PageMode` === i.configName && i.configValue === '0') !== -1
    }
  },
  methods: {
    ...mapActions('globalconfig', ['upadteConfig']),
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      if (matched.length !== 0) {
        if (matched[1].name === 'Triggers') {
          matched[1].name = 'Triggers'
          matched[1].path = '/dashboard/trigger'
          this.triggerId = this.$route.params.triggerId
        } else if (matched[1].meta.title === 'Describe') {
          matched[1].name = localStorage.channelName
          matched[1].path = '/dashboard/channel'
        } else if (matched[1].meta.title === 'Kafka Manage Describe') {
          matched[1].name = localStorage.channelName
          matched[1].path = '/dashboard/manage/cluster'
        } else if (matched[1].meta.title === 'Service Region' || matched[1].meta.title === 'Client') {
          matched[1].name = this.$route.params.name
          matched[1].path = '/dashboard/smart'
          matched.push({
            name: matched[1].meta.title,
            path: this.$route.path
          })
        } else if (matched[1].meta.title === 'Application' || matched[1].meta.title === 'Service Region Client') {
          matched[1].name = this.$route.params.serviceName
          matched[1].path = '/dashboard/smart'
          matched.push({
            name: this.$route.params.poolName,
            path: '/dashboard/smart/pool/' + this.$route.params.serviceName + '/' + this.$route.params.serviceId
          })
          matched.push({
            name: matched[1].meta.title,
            path: this.$route.path
          })
        } else if (matched[1].meta.title.indexOf('Kafka Manage') > -1) {
          // matched[1] = {
          //   name: 'Kafka Manage',
          //   path: '/dashboard/manage/cluster'
          // }
          this.isKafkaManage = true
          this.kafkaPath = {
            name: this.$route.name,
            path: this.$route.path
          }
          matched.splice(1, 1, {
            name: 'Kafka Manage',
            path: '/dashboard/manage/cluster'
          })
        }
      }
      this.levelList = matched
    },
    handleCommand(command) {
      if (command) {
        this.$router.push('/dashboard/manage/' + command)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.zm-breadcrumb {
  height: 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #d8dce5;
  line-height: 30px;
  padding-left: 10px;
}
</style>
<style>
.zm-breadcrumb__inner {
  max-width: 250px;
}
</style>
